export default function formatter(values) {
  const seenOrders = new Set();
  const params = [];

  Object.keys(values)
    .filter((key) => key.startsWith('key') && !key.includes('_'))
    .forEach((key) => {
      const order = parseInt(key.replace('key', ''), 10);
      const value = values[key];

      if (!seenOrders.has(order)) {
        params.push({ order, value });
        seenOrders.add(order);
      }
    });

  return {
    params,
    reportType: values.reportType,
  };
}
